import {Injectable} from '@angular/core';
import TIMES from "./times";
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/observable/of'; //proper way to import the 'of' operator
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/publishReplay';
import 'rxjs/add/operator/switchMap';
import {CookieService} from 'angular2-cookie/services/cookies.service';
import {
  ChronoField, DateTimeFormatter, LocalDate, LocalDateTime, LocalTime, nativeJs, TemporalField, use, ZonedDateTime,
  ZoneId, ZoneOffset,
  ZoneRegion
} from 'js-joda'
import {Http} from "@angular/http";
import {Local} from "protractor/built/driverProviders";
import DateTimeFormat = Intl.DateTimeFormat;
import {Observable} from "rxjs/Observable";
import {Subject} from "rxjs/Subject";
import {timestamp} from "rxjs/operator/timestamp";
import {ISO_8601} from "moment";
import {TimezoneService} from "app/Services/timezone/timezone.service";

declare var require: any;
use(require('js-joda-timezone'));

window['appointmentID'] = 0;

@Injectable()
export class AppointmentsService {

  timezoneService: TimezoneService;
  appointmentLocation = '';
  appointmentOutlook = '';

  getStaticTimes(): ZonedDateTime[] {
    return TIMES.map(time => {
      return ZonedDateTime.parse(LocalDate.now() + "T" + time + "-05:00");
    });
  }

  constructor(private http: Http, timezoneService: TimezoneService) {
    this.http = http;
    this.timezoneService = timezoneService;
  }

  getTimes(localDate: LocalDate): Observable<LocalTime[]> {
    var loader = document.getElementById('loader');
    if ( loader !== undefined && loader !== null ) {
      loader.classList.add('show');
    }
    var calendarID = window['ngRoot'].getAttribute('data-calendar'),
        calendarUrl = '';
    if (calendarID !== undefined && calendarID) {
      calendarUrl = '&calendarID=' + calendarID;
    }
    let observable = this.http.get(window['appointmentAPIurl'] + "availability_times.php?date=" + localDate.toString() + "&apt_id=" + window['appointmentType'] + calendarUrl + "&timezone=" + window['appointmentTimezone'].replace('+', '%2b'))
      .map((response) => {
        var json = response.json();
        if ( loader !== undefined && loader !== null ) {
          loader.classList.remove('show');
        }
        return json.map((timeObj) => {
          var newTime = timeObj["time"].split('T')[1].substring(0,8);
          var result = LocalTime.parse(newTime);
          return result;
        })
      })
      .publishReplay(1)
      .refCount();
    return observable;
  }

  getDates(month: LocalDate): Observable<LocalDate[]> {
    var calendarID = window['ngRoot'].getAttribute('data-calendar'),
        calendarUrl = '';
    if (calendarID !== undefined && calendarID) {
      calendarUrl = '&calendarID=' + calendarID;
    }
    let observable = this.http.get(window['appointmentAPIurl'] + "availability_dates.php?month=" + month.year() + "-" + month.monthValue() + "&apt_id=" + window['appointmentType'] + calendarUrl + "&timezone=" + window['appointmentTimezone'].replace('+', '%2b'))
      .map((response) => {
        return response.json().map((dateObj) => {
          return LocalDate.parse(dateObj["date"]);
        })
      })
      .publishReplay(1)
      .refCount();
    return observable;
  }

  cancelDemo(reschedule = false): Observable<any> {
    return this.http.get(window['appointmentAPIurl'] + "cancel.php?cancelID=" + window['appointmentID'])
      .map((response) => {
        let ans = JSON.parse(response['_body']);
        if ( ans.hasOwnProperty('message') ) {
          alert( ans.message );
          window.location.reload();
        } else {
          console.log('Appointment canceled: ' + ans.id);
          CookieService.prototype.remove('currentAPT');
          CookieService.prototype.remove('appointmentID');
          CookieService.prototype.remove('appointmentDate');
          if ( reschedule ) {
            alert('Current appointment canceled. Select a new date.');
          } else {
            let orange = document.getElementById('appointment-canceled');
            if ( orange !== undefined && orange !== null ) {
              orange.classList.add('show');
            }
          }
        }
        let loader = document.getElementById('loader');
        if ( loader !== undefined && loader !== null ) {
          loader.classList.remove('show');
        }
        let newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?cancel=1';
        window.location.replace(newUrl);
        return response;
      });
  }

  cancelDemoMobile(reschedule = false): Observable<any> {
    return this.http.get(window['appointmentAPIurl'] + "cancel.php?cancelID=" + window['appointmentID'])
      .map((response) => {
        let ans = JSON.parse(response['_body']);
        if ( ans.hasOwnProperty('message') ) {
          alert( ans.message );
          window.location.reload();
        } else {
          console.log('Appointment canceled: ' + ans.id);
          CookieService.prototype.remove('currentAPT');
          CookieService.prototype.remove('appointmentID');
          CookieService.prototype.remove('appointmentDate');
          if ( !reschedule ) {
            let newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?cancel=1';
            window.location.replace(newUrl);
          }
        }
        return response;
      });
  }

  createAppointment(dateInfo, contactInfo, isMobile = false): Observable<any> {
    let obj = {
      date: dateInfo,
      first_name: contactInfo.firstName,
      last_name: contactInfo.lastName,
      email: contactInfo.email,
      phone: contactInfo.phone,
      company: contactInfo.company,
      apt_id: window['appointmentType'],
      timezone: this.timezoneService.timezone.time,
    };
    var isAgencyTrue = false;
    if (window['ngRoot'] !== null) {
      isAgencyTrue = Boolean(window['ngRoot'].getAttribute('data-agency'));
      // if ( !isAgencyTrue ) {
        obj['website'] = contactInfo.website;
      // }
    }
    var calendarID = window['ngRoot'].getAttribute('data-calendar');
    if (calendarID !== undefined && calendarID) {
      obj['calendarID'] = calendarID;
    }
    return this.http.post(window['appointmentAPIurl'] + "appointment.php", JSON.stringify(obj))
      .map((response) => {
        console.log( response['statusText'] );
        let ans = JSON.parse(response['_body']);
        if ( !isMobile ) {
          document.getElementById('loader').classList.remove('show');
        }
        if ( ans.hasOwnProperty('message') ) {
          alert( ans.message );
          window.location.reload();
          return false;
        } else {
          this.gtmTracking();
          this.sharpspringNativeForm();

          console.log('Appointment created: ' + ans.id);
          window['appointmentID'] = ans.id;

          this.appointmentOutlook = ans.confirmationPage + '&m=cal';
          this.appointmentLocation = ans.location;

          let cookieExp = new Date(new Date().setMinutes(new Date().getMinutes() + 30));
          CookieService.prototype.put('currentAPT', window['appointmentType'], {path: '/', expires: cookieExp});
          CookieService.prototype.put('appointmentID', ans.id, {path: '/', expires: cookieExp});
          CookieService.prototype.put('appointmentDate', dateInfo, {path: '/', expires: cookieExp});
          CookieService.prototype.put('appointmentOutlook', ans.confirmationPage + '&m=cal', {path: '/', expires: cookieExp});
          CookieService.prototype.put('appointmentLocation', ans.location, {path: '/', expires: cookieExp});
          let cookieExp2 = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
          CookieService.prototype.put('firstName', contactInfo.firstName, {path: '/', expires: cookieExp2});
          CookieService.prototype.put('lastName', contactInfo.lastName, {path: '/', expires: cookieExp2});
          CookieService.prototype.put('phone', contactInfo.phone, {path: '/', expires: cookieExp2});
          CookieService.prototype.put('website', contactInfo.website, {path: '/', expires: cookieExp2});
          CookieService.prototype.put('company', contactInfo.company, {path: '/', expires: cookieExp2});
          CookieService.prototype.put('email', contactInfo.email, {path: '/', expires: cookieExp2});

          if ( !isMobile ) {
            this.googleLinkDesktop(dateInfo, ans.id);
            // window.location.href = '/resources/test-angular-result/';
          }
          return ans;
        }
      });
  }

  reschedule(dateInfo, isMobile = false): Observable<any> {
    const obj = {
      rescheduleID: CookieService.prototype.get('appointmentID'),
      datetime: dateInfo,
    };
    return this.http.post(window['appointmentAPIurl'] + 'reschedule.php', JSON.stringify(obj))
      .map((response) => {
        const ans = JSON.parse(response['_body']);
        const loader = document.getElementById('loader');
        if (loader) {
          loader.classList.remove('show');
        }
        if ( ans.hasOwnProperty('message') ) {
          alert( ans.message );
          window.location.reload();
          return false;
        } else {
          this.gtmTracking();

          console.log('Appointment rescheduled: ' + ans.id);
          window['appointmentID'] = ans.id;

          this.appointmentOutlook = ans.confirmationPage + '&m=cal';
          this.appointmentLocation = ans.location;

          let cookieExp = new Date(new Date().setMinutes(new Date().getMinutes() + 30));
          CookieService.prototype.put('currentAPT', window['appointmentType'], {path: '/', expires: cookieExp});
          CookieService.prototype.put('appointmentID', ans.id, {path: '/', expires: cookieExp});
          CookieService.prototype.put('appointmentDate', dateInfo, {path: '/', expires: cookieExp});
          CookieService.prototype.put('appointmentOutlook', ans.confirmationPage + '&m=cal', {path: '/', expires: cookieExp});
          CookieService.prototype.put('appointmentLocation', ans.location, {path: '/', expires: cookieExp});
          if ( !isMobile ) {
            this.googleLinkDesktop(dateInfo, ans.id);
            // window.location.href = '/resources/test-angular-result/?reschedule=1';
          }
          return ans.id;
        }
      });
  }

  googleLinkDesktop(dateInfo:any, id:any):void {
    var postID = '';
    var minutes = '60';
    if (window['ngRoot'] !== null) {
      postID = window['ngRoot'].getAttribute('data-postid');
      minutes = window['ngRoot'].getAttribute('data-minutes') || '60';
    }
    var dt1 = new Date(dateInfo.replace(/..$/, ':00'));
    var google_dt1 = dt1.toISOString().replace(/[-:+.]/g, '').replace('000Z', 'Z');
    dt1.setMinutes(dt1.getMinutes() + parseInt(minutes));
    var google_dt2 = dt1.toISOString().replace(/[-:+.]/g, '').replace('000Z', 'Z');
    var url = 'https://calendar.google.com/calendar/render?action=TEMPLATE&text=';
    url += 'Live SharpSpring Demo&'.replace(/ /g, "+");
    url += 'dates=' + google_dt1 + '/' + google_dt2 + '&';
    url += 'location=' + encodeURIComponent(this.appointmentLocation).replace(/%20/g, "+").replace(/\(/g, "%28").replace(/\)/g, "%29") + '&';
    url += 'details=' + encodeURIComponent(this.appointmentLocation + '\n\
\nView/Change Appointment:\n' + encodeURI('https://sharpspring.com/wp-content/plugins/acuity-scheduling-angular/api/get_appointment_info.php?apt_id='+id+'&post_id='+postID) + '\n\
\nWe are looking forward to chatting with you and showing you how SharpSpring marketing automation can help you grow your business.\n\
\nIn the meantime, check out some of our featured resources.\n\
\nTake Your Agency and Clients to the Next Level\nB2B and B2C Strategies\n\
\nDriving Growth & Producing Measurable Results\nInfographic\n\
\nMarketing Automation Playbook\nPump up your Campaigns\n\
\nGoogle').replace(/%20/g, "+").replace(/\(/g, "%28").replace(/\)/g, "%29");
    url += '&sf=true&output=xml';
    let cookieExp = new Date(new Date().setMinutes(new Date().getMinutes() + 30));
    CookieService.prototype.put('appointmentGoogle', url, { path: '/', expires: cookieExp });
    // View/Change Appointment:\n' + this.appointmentOutlook.slice(0, -6).replace(/id%5B%5D/g, "id[]")
  }

  gtmTracking():void {
    if ( window['ngRoot'] !== null ) {
      var gtm = window['ngRoot'].getAttribute('data-gtm');
      if ( gtm !== null ) {
        window['dataLayer'] = window['dataLayer'] || [];
        window['dataLayer'].push({event: gtm});
      }
    }
  }

  sharpspringNativeForm():void {
    if ( window['ngRoot'] !== null && window['__ss_noform'] !== undefined ) {
      var formID = window['ngRoot'].getAttribute('data-formid');
      var token = window['ngRoot'].getAttribute('data-token');
      if ( formID !== null && token !== null ) {
        window['__ss_noform'].push(['baseURI', 'https://app-724KI.marketingautomation.services/webforms/receivePostback/MwYA/']);
        window['__ss_noform'].push(['form', formID, token]);
        window['__ss_noform'].push(['submitType', 'manual']);
        window['__ss_noform'].push(['submit', null, token]);
      }
    }
  }

  private handleError(error: any): Promise<any> {
    // TODO: GREY OUT AND PLACE RED RECTANGLE OVER APP
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// /app/src/app/Services/appointments/appointments.service.ts